const NAMED_ENTITIES: Record<string, string> = {
    amp: '&',
    lt: '<',
    gt: '>',
    quot: '"',
    apos: '\''
};

const ENTITY = /&(?:#x([0-9a-f]+)|#([0-9]+)|(amp|lt|gt|quot|apos));/gi;

const MAX_CODE_POINT = 0x10FFFF;

// Decodes, once, the entities an HTML sanitizer writes into plain text. Escape the result again
// before putting it into HTML: innerHTML would turn a typed "<" into markup.
export const decodeHtmlEntities = (value: string): string => {
    return value.replace(ENTITY, (entity, hex: string | undefined, decimal: string | undefined, name: string | undefined) => {
        if (name) {
            return NAMED_ENTITIES[name.toLowerCase()];
        }
        const codePoint = hex ? parseInt(hex, 16) : Number(decimal);
        if (!Number.isInteger(codePoint) || codePoint < 1 || codePoint > MAX_CODE_POINT) {
            return entity;
        }
        return String.fromCodePoint(codePoint);
    });
};
